export default __webpack_public_path__ + "static/media/maximize.9bbe9027.svg";